import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import servicesApi from "../../../seller-apis/servicesApi";
import api from "../../../seller-apis/api";
import {
  categoryProductList,
  pendforapprovProducts,
  pendingProducts,
} from "../../../seller-apis/apidataField";
import PaginationCom from "../../common/Pagination";
import AddNewProductCardDesign from "../../common/AddNewProductCardDesign";
import "./category-hierarchy.css";
import { useAlert } from "react-alert";
import PopupAddCombination from "../../common/PopupAddCombination";
import AddProductFromCataloguePopup from "../../common/AddProductFromCataloguePopup";
import CategoryProductPopup from "./CategoryProductPopup";


let timeOutId;
let srchVal = "";
let isNewVend;
let NewVendTotalprcount = 0;



function Category() {
  let history = useHistory();
  const alert = useAlert();

  // State Management
  const [categoryTree, setCategoryTree] = useState([]);
  const [selectedGrandparent, setSelectedGrandparent] = useState("");
  const [selectedParent, setSelectedParent] = useState("");
  const [selectedChild, setSelectedChild] = useState("");

  const [parentOptions, setParentOptions] = useState([]);
  const [childOptions, setChildOptions] = useState([]);

  const [searchType, setSearchType] = useState("Product Name");
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  const [products, setProducts] = useState([]);
  const [productRecords, setProductRecords] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [productPopupData, setProductPopupData] = useState({});

  // Popup for product details view
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [currentProductDetail, setCurrentProductDetail] = useState(null);

  // Initialize
  useEffect(() => {
    loadCategoryTree();
    checkNewVendor();
    loadAllProducts(); // Load all products on initial render
  }, []);

  // Load all products initially
  const loadAllProducts = async (page = 1) => {
    setLoading(true);
    try {
      const data = {
        pageNo: page.toString(),
        categoryId: "",
        vendors: {
          $not: {
            $elemMatch: {
              vendor_id: localStorage.getItem("vendorId"),
              combination: {$exists: true, $eq: []},
              vActive: "ACTIVE",
            }
          }
        }
      };
      const res = await api.product.categoryProductList(categoryProductList(data));
      setProducts(res.products);
      setProductRecords(res.totalRecords);
      setSelectedPage(page);
    } catch (err) {
      console.error("Error loading products:", err);
      alert.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  const loadCategoryTree = async () => {
    try {
      const res = await servicesApi.categories.categoryTree({});
      setCategoryTree(res.data.subCategories);
    } catch (err) {
      console.error("Error loading categories:", err);
      alert.error("Failed to load categories");
    }
  };

  const checkNewVendor = async () => {
    if (window.location.href.includes("newVendor")) {
      isNewVend = true;
      try {
        const filter = { pageNo: "1" };
        const [pendingRes, approvalRes] = await Promise.all([
          api.product.newProductsRetrieveall(pendingProducts(filter)),
          api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filter))
        ]);
        NewVendTotalprcount = pendingRes.totalRecords + approvalRes.totalRecords;
      } catch (err) {
        console.error("Error checking vendor status:", err);
      }
    }
  };

  // Handle Grandparent Category Selection
  const handleGrandparentChange = (e) => {
    const value = e.target.value;
    setSelectedGrandparent(value);
    setSelectedParent("");
    setSelectedChild("");
    setParentOptions([]);
    setChildOptions([]);

    if (value) {
      const grandparent = categoryTree.find(cat => cat._id === value);
      if (grandparent) {
        if (grandparent.subCategories && grandparent.subCategories.length > 0) {
          setParentOptions(grandparent.subCategories);
        }
        loadProducts(value);
      }
    } else {
      setProducts([]);
      loadAllProducts();
    }
  };

  // Handle Parent Category Selection
  const handleParentChange = (e) => {
    const value = e.target.value;
    setSelectedParent(value);
    setSelectedChild("");
    setChildOptions([]);

    if (value) {
      const parent = parentOptions.find(cat => cat._id === value);
      if (parent) {
        if (parent.subCategories && parent.subCategories.length > 0) {
          setChildOptions(parent.subCategories);
        }
        loadProducts(value);
      }
    } else {
      if (selectedGrandparent) {
        loadProducts(selectedGrandparent);
      }
    }
  };

  // Handle Child Category Selection
  const handleChildChange = (e) => {
    const value = e.target.value;
    setSelectedChild(value);
    if (value) {
      loadProducts(value);
    }
  };

  // Load Products
  const loadProducts = async (categoryId, page = 1) => {
    setLoading(true);
    try {
      const data = {
        pageNo: page.toString(),
        categoryId: categoryId,
        vendors: {
          $not: {
            $elemMatch: {
              vendor_id: localStorage.getItem("vendorId"),
              combination: {$exists: true, $eq: []},
              vActive: "ACTIVE",
            }
          }
        }
      };
      const res = await api.product.categoryProductList(categoryProductList(data));
      setProducts(res.products);
      setProductRecords(res.totalRecords);
      setSelectedPage(page);
    } catch (err) {
      console.error("Error loading products:", err);
      alert.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  // Search Functionality
  const handleSearch = async () => {
    if (!srchVal || srchVal.length < 3) {
      setSearchResults([]);
      return;
    }

    const param = searchType === "SKU"
      ? { "SKU-partial": srchVal }
      : { "productName-fuzzy": srchVal };

    const filed = { "productName": 1, "SKU": 1 };
    const paramData = {
      filter: { ...param },
      otherFilter: {},
      excludeField: { ...filed },
    };

    try {
      const res = await api.product.searchSellerProducts(paramData);
      setSearchResults(res.products);
      setShowSearchDropdown(true);
    } catch (err) {
      console.error("Error searching products:", err);
    }
  };

  const handleSearchInput = (text) => {
    srchVal = text;
    setSearchText(text);
    clearTimeout(timeOutId);

    if (!text) {
      setSearchResults([]);
      setShowSearchDropdown(false);
    } else if (text.length > 2) {
      timeOutId = setTimeout(handleSearch, 900);
    }
  };

  const handleSearchResultClick = async (sku) => {
    try {
      const data = {
    pageNo: 1,
    size: 15,
    filter: {
        SKU: { $in: [sku] }
    },
    sortFilter: {
        completeSellOrderCount: -1,
        productViewCount: -1,
        displayActualPrice: -1
    },
    excludeField: {}
    };
      const res = await api.product.searchProducts(data);
      if (res.products && res.products.length > 0) {
        const product = res.products[0];
        openProductPopup(product);
      }
      setShowSearchDropdown(false);
      setSearchText("");
      setSearchResults([]);
    } catch (err) {
      console.error("Error getting product details:", err);
    }
  };

  const handleSearchRedirect = () => {
    if (srchVal) {
      const encodedValue = encodeURIComponent(srchVal);
      const encodedType = encodeURIComponent(searchType);
      window.location.assign(`/searchProductsList/${encodedValue}?type=${encodedType}`);
    }
  };

  const handleSearchKeyPress = (e) => {
    if (e.keyCode === 13 && srchVal) {
      handleSearchRedirect();
    }
  };

  // Product Actions - Open popup for adding product
  const openProductPopup = (product) => {
    let baseImg = "";
    product.images.forEach((item) => {
      if (item.baseImage) {
        if (item.image.startsWith("products") || item.image.startsWith("mob")) {
          baseImg = item.image;
        } else {
          baseImg = item.image.substr(41);
        }
      }
    });

    setProductPopupData({
      SKU: product.SKU,
      taxClass: product.taxClass,
      pkgs: product.pkgs,
      categories: product.categories,
      shortDescription: product.shortDescription,
      description: product.description,
      descriptionNew: product.descriptionNew,
      specificationNew: product.specificationNew,
      attributeList: product.attributeList,
      combination: product.combination,
      vendor: product.vendors?.[0],
      product: product,
      manufacturerName: product.manufacturerName || "",
      exProductReqData: product.exProductReqData,
    });

    setSelectedProduct({
      id: product._id,
      name: product.productName,
      image: baseImg,
      allImages: product.images,
      price: product.lowestPrice,
    });

    setShowProductPopup(true);
  };

  // Handle card click to show product details popup
  const handleCardClick = (product) => {
    setCurrentProductDetail(product);
    setShowDetailPopup(true);
  };

  const closeDetailPopup = () => {
    setShowDetailPopup(false);
    setCurrentProductDetail(null);
  };

  const closeProductPopup = () => {
    setShowProductPopup(false);
    setSelectedProduct(null);
    setProductPopupData({});
  };

  const handleProductCallback = (msg, type) => {
    if (msg === "product added" || msg === "product updated") {
      closeProductPopup();
      if (type !== "combination") {
        alert.success("Product Added Successfully");
      }
      const currentCategoryId = selectedChild || selectedParent || selectedGrandparent;
      if (currentCategoryId) {
        loadProducts(currentCategoryId, selectedPage);
      } else {
        loadAllProducts(selectedPage);
      }
    } else if (msg === null && type === "combination") {
      closeProductPopup();
    } else {
      closeProductPopup();
      alert.error("Product not added");
    }
  };

  // Pagination
  const handlePagination = (pageData) => {
    const currentCategoryId = selectedChild || selectedParent || selectedGrandparent;
    if (currentCategoryId) {
      loadProducts(currentCategoryId, pageData.number);
    } else {
      loadAllProducts(pageData.number);
    }
  };

  // Get category name for badge
  const getCategoryInfo = () => {
    let categoryName = "";
    let subcategoryName = "";

    if (selectedChild) {
      const child = childOptions.find(cat => cat._id === selectedChild);
      categoryName = child?.categoryName || "";
      const parent = parentOptions.find(cat => cat._id === selectedParent);
      subcategoryName = parent?.categoryName || "";
    } else if (selectedParent) {
      const parent = parentOptions.find(cat => cat._id === selectedParent);
      categoryName = parent?.categoryName || "";
      const grandparent = categoryTree.find(cat => cat._id === selectedGrandparent);
      subcategoryName = grandparent?.categoryName || "";
    } else if (selectedGrandparent) {
      const grandparent = categoryTree.find(cat => cat._id === selectedGrandparent);
      categoryName = grandparent?.categoryName || "";
    }

    return { categoryName, subcategoryName };
  };

  const getDropdownGridClass = () => {
    if (childOptions.length > 0) return "has-3";
    if (parentOptions.length > 0) return "has-2";
    return "has-1";
  };

  return (
    <div className="category-container">

      {/* ── STICKY HEADER: search + category filter ── */}
      <div className="category-sticky-header">

        {/* Search Section */}
        <div className="search-section">
          <div className="search-wrapper">
            <select
              className="search-type-select"
              value={searchType}
              onChange={(e) => {
                setSearchType(e.target.value);
                setSearchText("");
                srchVal = "";
                setSearchResults([]);
                setShowSearchDropdown(false);
              }}
            >
              <option value="Product Name">Product Name</option>
              <option value="SKU">SKU</option>
            </select>

            <input
              type="text"
              className="search-input-box"
              value={searchText}
              onChange={(e) => handleSearchInput(e.target.value)}
              onKeyUp={handleSearchKeyPress}
              placeholder={`Search products by ${searchType.toLowerCase()}...`}
            />

            <button className="search-button" onClick={handleSearchRedirect}>
              <i className="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>

          {showSearchDropdown && searchResults.length > 0 && (
            <div className="search-results-dropdown">
              {searchResults.map((item, index) => (
                <div
                  key={index}
                  className="search-result-item"
                  onClick={() => handleSearchResultClick(item.SKU)}
                >
                  <div className="search-result-text">
                    <h4>{item.productName}</h4>
                    <p>SKU: {item.SKU}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Category Dropdown Section */}
        <div className="category-dropdown-section">
          <div className="category-header">
            SELECT CATEGORIES TO FILTER PRODUCTS
          </div>

          <div className={`category-dropdowns-row ${getDropdownGridClass()}`}>
            {/* Grandparent */}
            <div className="dropdown-wrapper">
              <label className="dropdown-label">Grand Category</label>
              <select
                className="category-select"
                value={selectedGrandparent}
                onChange={handleGrandparentChange}
              >
                <option value="">Select Grand Category</option>
                {categoryTree.map((cat) => (
                  <option key={cat._id} value={cat._id}>{cat.categoryName}</option>
                ))}
              </select>
            </div>

            {/* Parent */}
            {parentOptions.length > 0 && (
              <div className="dropdown-wrapper">
                <label className="dropdown-label">Parent Category</label>
                <select
                  className="category-select"
                  value={selectedParent}
                  onChange={handleParentChange}
                >
                  <option value="">Select Parent Category</option>
                  {parentOptions.map((cat) => (
                    <option key={cat._id} value={cat._id}>{cat.categoryName}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Child */}
            {childOptions.length > 0 && (
              <div className="dropdown-wrapper">
                <label className="dropdown-label">Child Category</label>
                <select
                  className="category-select"
                  value={selectedChild}
                  onChange={handleChildChange}
                >
                  <option value="">Select Child Category</option>
                  {childOptions.map((cat) => (
                    <option key={cat._id} value={cat._id}>{cat.categoryName}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

      </div>{/* end .category-sticky-header */}

      {/* Products Grid */}
      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : products.length > 0 ? (
        <div className="products-section">
          <div className="products-grid">
            {products.map((product, index) => {
              let isAllCombSelected = false;
              let isPending = false;

              let isAllCombReqPend = false;
              let isAllCombReqApprov = false;
              if (product.combination && product.combination.length > 0) {
                let combsFilled = 0;
                let pendCombs = 0;

                // for combination only SL-1143
                let expRoductPendingReq = 0;
                let expRoductApprovedReq = 0;
                product.combination.map((comb, ic) => {
                    if (product?.exProductReqData && product?.exProductReqData.length > 0) {
                        for (let j = 0; j < product.exProductReqData.length; j++) {
                            if (comb.url === product.exProductReqData[j]?.combination?.url) {
                              expRoductPendingReq = expRoductPendingReq + 1;
                              if (product.exProductReqData[j]?.status === "APPROVED") {
                                  expRoductApprovedReq = expRoductApprovedReq + 1
                              }
                            }
                        }
                    }
                });
                if (expRoductPendingReq >= product.combination.length - 1 || expRoductApprovedReq >= product.combination.length - 1) {
                    if (expRoductPendingReq === expRoductApprovedReq) {
                        isAllCombReqApprov = true;
                    } else {
                        isAllCombReqPend = true;
                    }
                }

                if (product.vendors && product.vendors[0] && product.vendors[0].combination) {
                  product.vendors[0].combination.forEach((comb) => {
                    if (comb.purchase_price && comb.active && comb.vActive === "ACTIVE") combsFilled++;
                    if (comb.purchase_price) pendCombs++;
                  });

                  if (combsFilled === product.combination.length - 1) isAllCombSelected = true;
                  if (pendCombs === product.combination.length - 1) isPending = true;
                }
              }

              const categoryInfo = getCategoryInfo();

              return (
                <AddNewProductCardDesign
                  key={index}
                  id={index}
                  lead={product._id}
                  vendors={product.vendors}
                  images={product.images}
                  productName={product.productName}
                  SKU={product.SKU}
                  price={product.lowestPrice}
                  categoryName={categoryInfo.categoryName}
                  subcategoryName={categoryInfo.subcategoryName}
                  shortDescription={product.shortDescription}
                  manufacturerName={product.manufacturerName}
                  updtprofun={() => openProductPopup(product)}
                  onViewDetails={() => handleCardClick(product)}
                  isAllcomb={isAllCombSelected}
                  isPend={isPending}
                  exProductReq={product.exProductReq}
                  hidePrice={true}
                  showSKU={true}
                  isAllCombReqPend={isAllCombReqPend}
                  isAllCombReqApprov={isAllCombReqApprov}
                />
              );
            })}
          </div>

          {productRecords > 15 && (
            <div className="mt-3">
              <PaginationCom
                number={productRecords}
                paginate={handlePagination}
                activ={selectedPage}
                perPage="15"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="fa fa-inbox" aria-hidden="true"></i>
          </div>
          <h3 className="empty-title">No Products Found</h3>
          <p className="empty-message">Try selecting a different category or search for products</p>
        </div>
      )}

      {/* Product Detail Popup */}
      {showDetailPopup && currentProductDetail && (
        <CategoryProductPopup
          description={currentProductDetail.description}
          sdescription={currentProductDetail.shortDescription}
          descriptionNew={currentProductDetail.descriptionNew || []}
          specificationNew={currentProductDetail.specificationNew || []}
          name={currentProductDetail.productName}
          price={currentProductDetail.lowestPrice}
          SKU={currentProductDetail.SKU}
          onClose={closeDetailPopup}
          images={currentProductDetail.images}
          pkgs={currentProductDetail.pkgs}
          manufacturerName={currentProductDetail.manufacturerName}
        />
      )}

      {/* Product Add/Edit Popup */}
      {showProductPopup && selectedProduct && (
        productPopupData.attributeList?.length > 0 ? (
          <PopupAddCombination
            lead={selectedProduct.id}
            productName={selectedProduct.name}
            Popupvisible="block"
            img={selectedProduct.image}
            allImages={selectedProduct.allImages}
            detail={productPopupData}
            handleDetail={() => { }}
            Popupvisibilityfun={closeProductPopup}
            from="chooseProduct"
            callbackResFun={handleProductCallback}
            flag="TV Catalogue"
          />
        ) : (
          <AddProductFromCataloguePopup
            lead={selectedProduct.id}
            productName={selectedProduct.name}
            Popupvisible="block"
            img={selectedProduct.image}
            allImages={selectedProduct.allImages}
            lowestPrice={selectedProduct.price}
            detail={productPopupData}
            Popupvisibilityfun={closeProductPopup}
            from="chooseProduct"
            flag="TV Catalogue"
            callbackResFun={handleProductCallback}
          />
        )
      )}
    </div>
  );
}

export default Category;